import React from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const MiscInformation = ({ data, label }) => (
  <Stack spacing={1} sx={{ px: 2 }}>
    <Typography sx={{ fontSize: 16, fontWeight: 300 }} variant="subtitle1">
      {label}
    </Typography>
    <Typography variant="subtitle2">{data || '--'}</Typography>
  </Stack>
);

MiscInformation.defaultProps = {
  data: '',
};

MiscInformation.propTypes = {
  data: PropTypes.string,
  label: PropTypes.string.isRequired,
};

export default MiscInformation;
